// Elements
const newQuickShopDrawer = document.querySelector(`#new-quick-shop-drawer`)


// Variables
let currentProduct = {}
let membershipPackId = ''
let membershipSellingPlanID = ''
let options = {}

let isKitGroup = false
let isShoppablePictureGallery = false
let currentKitProducts = []

const SHOPIFY_STORE = window.ENV?.SHOPIFY_STORE;
const STOREFRONT_ACCESS_TOKEN = window.ENV?.STOREFRONT_ACCESS_TOKEN
const GRAPHQL_URL = `https://${SHOPIFY_STORE}.myshopify.com/api/2024-04/graphql.json`

const fetchProductData = async (productId) => {
	const gid = `gid://shopify/Product/${productId}`

	const res = await fetch(GRAPHQL_URL, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
		},
		body: JSON.stringify({
			query: `
				query getProduct($id: ID!) {
				  product(id: $id) {
					id
					title
					handle
					productType
					images(first: 20) {
					  edges { node { src altText } }
					}
					variants(first: 100) {
					  edges {
						node {
						  id
						  title
						  sku
						  availableForSale
						  requiresShipping
						  taxable
						  quantityAvailable
						  compareAtPrice { amount }
						  price { amount currencyCode }
						  weight
						  barcode
						  selectedOptions { name value }
						  sellingPlanAllocations(first: 5) {
							edges { node { sellingPlan { id } } }
						  }
						}
					  }
					}
					options {
					  name
					  values
					}
					metafields(identifiers: [
					  { namespace: "custom", key: "kit" },
					  { namespace: "custom", key: "kit_group" },
					  { namespace: "custom", key: "show_membership_pack_product_detail" },
					  { namespace: "custom", key: "membership_pack" },
					  { namespace: "custom", key: "hide_short_for_markets" },
					  { namespace: "custom", key: "hide_tall_for_markets" }
					]) {
					  key
					  value
					  type
					  namespace
					  reference {
						... on Product {
						  id
						  title
						  handle
						  options { name values }
						  metafield(namespace: "custom", key: "kit_group") { value }
						}
					  }
					}
				  }
				}
			  `,

			variables: { id: gid }
		})
	});

	const json = await res.json();
	const p = json.data.product;

	const images = p.images.edges.map(e => e.node);
	const metafields = Object.fromEntries(p.metafields.map(mf => [mf?.key, mf]));

	const options = p.options.map((opt, index) => ({
		name: opt.name,
		position: index + 1,
		values: opt.values
	}));

	const variants = p.variants.edges.map(({ node }) => {
		const optionsList = node.selectedOptions.map(o => o.value);
		return {
			id: parseInt(node.id.split("/").pop()),
			title: node.title,
			option1: optionsList[0] || null,
			option2: optionsList[1] || null,
			option3: optionsList[2] || null,
			sku: node.sku,
			requires_shipping: node.requiresShipping,
			taxable: node.taxable,
			featured_image: null,
			available: node.availableForSale,
			name: `${p.title} - ${node.title}`,
			public_title: node.title,
			options: optionsList,
			price: parseInt(node.price.amount * 100),
			weight: node.weight,
			compare_at_price: parseInt(node.compareAtPrice?.amount || 0),
			inventory_management: null, // not in Storefront API
			barcode: node.barcode,
			requires_selling_plan: node.sellingPlanAllocations.edges.length > 0,
			selling_plan_allocations: node.sellingPlanAllocations.edges.map(e => e.node),
			quantity_rule: {
				min: 1,
				max: null,
				increment: 1
			}
		};
	});

	const tempObject = {
		id: p.id,
		title: p.title,
		type: p.productType,
		price: variants[0]?.price ?? null,
		handle: p.handle,
		variants,
		images,
		options_with_values: options,
	};

	// Membership pack info
	const membershipPack = metafields.membership_pack?.reference;
	if (membershipPack) {
		const variant = membershipPack.variants?.edges?.[0]?.node;
		if (variant) {
			tempObject.membership_pack_id = variant.id;
			const sp = variant.sellingPlanAllocations?.edges?.[0]?.node?.sellingPlan;
			if (sp) {
				tempObject.membership_selling_plan_id = sp.id;
			}
		}
	}

	// Optional metafields
	if (metafields.hide_short_for_markets?.value) {
		tempObject.hide_short_for_markets = metafields.hide_short_for_markets.value;
	}
	if (metafields.hide_tall_for_markets?.value) {
		tempObject.hide_tall_for_markets = metafields.hide_tall_for_markets.value;
	}

	// Kit products handling
	const kitProducts = [];
	const kitArray = JSON.parse(metafields.kit?.value || '[]');
	for (const i of kitArray) {
		const ref = i?.product?.value || i?.product;
		if (ref && typeof ref === 'object') {
			kitProducts.push({
				...ref,
				kit_group: ref.metafields?.custom?.kit_group?.value || null,
				options_with_values: ref.options || []
			});
		}
	}
	if (kitProducts.length) {
		tempObject.kit_products = kitProducts;
	}

	return tempObject;
};


// Methods
async function openNewQuickShop(e) {
	e.preventDefault()
	e.stopPropagation()

	const button = e.currentTarget

	const productId = button.getAttribute('data-product-id')
	const sectionId = button.getAttribute('data-section-id')

	isKitGroup = !!button.getAttribute('data-is-kit-group')
	isShoppablePictureGallery = !!button.getAttribute('data-is-shoppable-picture-gallery')

	currentProduct = window.globalProductObject?.find(productObject => productObject?.id === Number(productId)) || await fetchProductData(productId)

	if (isKitGroup && currentProduct?.kit_products) currentKitProducts = currentProduct.kit_products

	membershipPackId = button.getAttribute('data-membership-pack-id') || currentProduct?.membership_pack_id || ''
	membershipSellingPlanID = button.getAttribute('data-membership-selling-plan-id') || currentProduct?.membership_selling_plan_id || ''

	if (currentProduct) {
		renderOptions()

		if (!isMobile()) {
			const parentElement = isShoppablePictureGallery
				? document.querySelector(`div.new-quick-shop-drawer-wrapper[data-section-id="${sectionId}"]`)
				: document.querySelector(`div.new-quick-shop-drawer-wrapper[data-section-id="${sectionId}"][data-product-id="${productId}"]`)
			if (parentElement) parentElement.append(newQuickShopDrawer)
		}

		newQuickShopDrawer.classList.add('is-open')
	} else {
		console.error('new-quick-shop.js => openNewQuickShop() => currentProduct is: ', currentProduct)
	}
}

function getHideFlags({ product, settings, marketHandle }) {
	let hideShort = false
	let hideTall = false

	const hideShortMarkets = product?.hide_short_for_markets || []
	const hideTallMarkets = product?.hide_tall_for_markets || []

	const resolveMarketHandle = (market) => {
		const key = `${market.title.toLowerCase()}_market_handle`
		return settings[key]
	}

	for (const market of hideShortMarkets) {
		if (resolveMarketHandle(market) === marketHandle) {
			hideShort = true
			break
		}
	}

	for (const market of hideTallMarkets) {
		if (resolveMarketHandle(market) === marketHandle) {
			hideTall = true
			break
		}
	}

	return { hideShort, hideTall }
}

function closeNewQuickShop(e) {
	if (e) {
		e.preventDefault()
		e.stopPropagation()
	}

	newQuickShopDrawer.classList.remove('is-open')

	optionsRemoveEventListener()
	resetVariables()
}


// Render Methods
function renderOptions() {
	const { hideShort, hideTall } = getHideFlags({
		product: currentProduct,
		settings: window.ShopData?.settings,
		marketHandle: window.ShopData?.market
	})

	const initProduct = isKitGroup
		? findObjectWithLongestArray(currentKitProducts, 'options_with_values')
		: currentProduct

	const optionsWithValues = initProduct.options_with_values
	const productOptions = newQuickShopDrawer.querySelector(`#product-options-wrapper`)

	let optionsHTML = ''

	optionsWithValues.forEach(product_option => {
		const hideLengthBlock = product_option.name === 'Length' && hideShort && hideTall

		let optionsBlockHTML = `
			<div class="options-block"${hideLengthBlock ? ' style="display: none"' : '' }>
				<label for="${product_option.name}" class="name-options">Select ${product_option.name}
					<span class="selected-option" data-selected-postion="${product_option.position}"></span>
				</label>
				
				<div class="options option-count-${product_option.values?.length}">
				
					${product_option.values?.map(value => {
						if ((value === 'Short' && hideShort) || (value === 'Tall' && hideTall)) return ''
			
						return `
							<div class="option">
								<input
									id="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.replace(`"`, '').toLowerCase()}-quick-shop"
									class="input-option"
									autocomplete="off"
									data-option-position="${product_option.position}"
									type="radio"
									name="${product_option.name.toLowerCase()}-quick-shop"
									value="${value}"
								>
					
								<label class="label-option" for="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.replace(`"`, '').toLowerCase()}-quick-shop">${sizeSimplify(value)}</label>
							</div>
						`
					}).join('')}
					
				</div>
			</div>
		`

		optionsHTML = `${optionsHTML}${optionsBlockHTML}`
	})

	productOptions.innerHTML = optionsHTML

	optionsAddEventListener()
	checkSoldout()


	if (hideShort && hideTall) {
		const lengthRegularEl = document.querySelector('#option-length-regular-quick-shop')

		if (lengthRegularEl) {
			lengthRegularEl.checked = true
			lengthRegularEl.dispatchEvent(new Event('change', { bubbles: true }))
		}
	}
}

function optionsAddEventListener() {
	newQuickShopDrawer.querySelectorAll(`.input-option`)?.forEach(option => {
		option.addEventListener('change', e => setOption(e.currentTarget))
	})
}

function optionsRemoveEventListener(optionsEl) {
	newQuickShopDrawer.querySelectorAll(`.input-option`)?.forEach(option => {
		option.removeEventListener('change', setOption, false)
	})
}

function setOption(currentTarget) {
	const value = currentTarget.value
	const position = currentTarget.getAttribute('data-option-position')

	const selectedSpan = newQuickShopDrawer.querySelector(`span[data-selected-postion="${position}"]`)
	if (selectedSpan) selectedSpan.innerText = value

	options[`option${position}`] = value

	checkSoldout()
	checkSelectedAllOptions()
}

function checkSoldout() {
	document.querySelectorAll('#new-quick-shop-drawer .input-option')?.forEach(option => {
		const initOptions = { ...options }

		const value = option.value
		const position = option.getAttribute('data-option-position')

		initOptions[`option${position}`] = value

		const variantsFiltered = isKitGroup
			? productGroupVariantsHandler(initOptions, currentKitProducts, 'filter')
			: productVariantsHandler(initOptions, currentProduct, 'filter')

		if (variantsFiltered) {
			let available = true

			if (isKitGroup) {
				variantsFiltered.forEach(v => {
					if (v.length && !v.some(e => e.available)) available = false
				})
			} else available = variantsFiltered.some(e => e.available)

			if (available) {
				option.parentElement.classList.remove('soldout')
				option.parentElement.classList.add('available')
			} else {
				option.parentElement.classList.remove('available')
				option.parentElement.classList.add('soldout')
			}
		}
	})
}

function checkSelectedAllOptions() {
	const optionsBlockEls = document.querySelectorAll(`#product-options-wrapper .options-block`)
	const inputOptionCheckedEls = document.querySelectorAll(`#product-options-wrapper .input-option:checked`)

	if ( optionsBlockEls.length === inputOptionCheckedEls.length) handleNewQuickShopAddToCart()
}

function productVariantsHandler(initOptions, product = {}, method) {
	const variants = product.variants

	if (!initOptions || !variants) return false

	return variants[method](variant => {
		// checking for out of stock when if first option is not selected
		const optionsKeys = Object.keys(initOptions)
		const productOptionsLength = product.options?.length || Number(product.option_size) || 0

		if ((optionsKeys.length === 1 || productOptionsLength === 1) && !product.kit_group) {
			const optionKey = optionsKeys[0]
			return variant[optionKey]?.replace('\"', '') === initOptions[optionKey]
		}

		return compareOptions(initOptions, variant)
	})
}

function productGroupVariantsHandler(initOptions, products = [], method) {
	let fullVar = []

	products.forEach(product => {
		fullVar.push(product.variants[method](variant => compareOptions(initOptions, variant)))
	})

	return fullVar
}

function compareOptions(initOptions, variant) {
	if (isKitGroup) {
		const initVariantOptions = variant.options

		initVariantOptions.forEach((v, index) => initVariantOptions[index] = handleVariant(v))

		const existOptions = []

		if (initVariantOptions.includes(initOptions['option1'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option2'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option3'])) existOptions.push(true)

		return existOptions.length === initVariantOptions.length
	}

	let result = false

	if (initOptions['option1']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1']
	}

	if (initOptions['option1'] && initOptions['option2']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1'] && variant.option2?.replace('\"', '') === initOptions['option2']
	}

	if (initOptions['option1'] && initOptions['option2'] && initOptions['option3']) {
		result = variant.option1?.replace('\"', '') === initOptions['option1'] && variant.option2?.replace('\"', '') === initOptions['option2'] && variant.option3?.replace('\"', '') === initOptions['option3']
	}

	return result
}

function handleNewQuickShopAddToCart() {
	newQuickShopDrawer.classList.remove('is-open') // There’s a weird delay in hiding the newQuickShopDrawer on iPhone (workaround needed).

	if (isKitGroup) {

		let kitProducts = []

		currentKitProducts.forEach(kitProduct => {
			const variant = productVariantsHandler(options, kitProduct, 'find')
			if (variant) kitProducts.push({ id: variant.id, quantity: 1 })
		})

		if (membershipPackId && membershipSellingPlanID) {
			kitProducts.push({ id: membershipPackId, selling_plan: membershipSellingPlanID, quantity: 1 })
		}

		bundleAddtocart(kitProducts) // custom.js method

	} else {

		const qtyVal = 1
		const variant = productVariantsHandler(options, currentProduct, 'find')

		if (variant) {
			addtocart(variant.id, qtyVal, membershipPackId, '', true, membershipSellingPlanID) // custom.js method
		}

	}

	closeNewQuickShop()
}

function handleVariant(variant) {
	return variant?.replace('\"', '')
}

function resetVariables() {
	currentProduct = {}
	options = {}
	currentKitProducts = []
	isKitGroup = false
}

function isMobile() {
	return window.innerWidth < 491
}

function sizeSimplify(size = '') {
	if (!size) return

	const initSize = size.toLowerCase()

	switch (true) {
		case initSize === 'xsmall':
			return 'XS'

		case initSize === 'small':
			return 'S'

		case initSize === "medium":
			return 'M'

		case initSize === 'large':
			return 'L'

		case initSize === "xlarge":
			return 'XL'

		case initSize === "2xlarge":
			return '2XL'

		case initSize === "3xlarge":
			return '3XL'

		case initSize === "4xlarge":
			return '4XL'

		case initSize === "5xlarge":
			return '5XL'

		default:
			return size
	}
}

function findObjectWithLongestArray(objects, key) {
	return objects.reduce((maxObj, currentObj) => {
		return (Array.isArray(currentObj[key]) && currentObj[key].length > (maxObj[key]?.length || 0))
			? currentObj
			: maxObj;
	}, {});
}
